package org.gymly.model

/**
 * Estado del asistente para el usuario actual. habilitado: el interruptor general está encendido.
 * puedeUsar: tiene el permiso. chatLibre: hay un modelo listo para el chat libre.
 */
data class AsistenteEstado(
    val habilitado: Boolean,
    val puedeUsar: Boolean,
    val chatLibre: Boolean,
)

/** Respuesta del asistente: el texto, cuántas consultas hizo y la conversación para seguir el hilo. */
data class AsistenteRespuesta(
    val conversacionId: String?,
    val texto: String,
    val herramientasUsadas: Int,
)

/** Una conversación del historial del usuario: su fecha y la primera pregunta. */
data class AsistenteConversacion(
    val id: String,
    val creadaEn: String,
    val primeraPregunta: String,
)

/** Un mensaje de una conversación. rol: "USUARIO" o "ASISTENTE". */
data class AsistenteMensaje(
    val rol: String,
    val texto: String,
    val creadoEn: String,
)

/** Una conversación de otro usuario, vista desde la auditoría. */
data class AsistenteConversacionAuditada(
    val id: String,
    val usuario: String,
    val creadaEn: String,
    val primeraPregunta: String,
)

/** Pregunta que el asistente no pudo responder con datos, con cuántas veces se hizo. */
data class AsistentePreguntaSinRespuesta(
    val pregunta: String,
    val veces: Int,
    val ultima: String,
)

/** Nombre, color y logo con los que se muestra el asistente. */
data class AsistentePersonalizacion(
    val nombre: String,
    val color: String,
    val logoUrl: String?,
)

/** Un proveedor que se puede elegir al crear una cuenta (Gemini, Anthropic, OpenAI, Groq...). */
data class AsistenteCatalogo(
    val codigo: String,
    val nombre: String,
    val tipo: String,
    val baseUrl: String?,
)

/** Una cuenta de modelo de IA con sus límites. La clave nunca viene del servidor. */
data class AsistenteProveedor(
    val id: String,
    val nombre: String,
    val tipo: String,
    val baseUrl: String?,
    val modelo: String,
    val activo: Boolean,
    val tieneClave: Boolean,
    val limiteMensualCents: Long,
    val limiteDiarioTokens: Long,
    val maxTokensSalida: Int,
    val precioEntradaPorMillon: Long,
    val precioSalidaPorMillon: Long,
    val gastoMesCents: Long,
    val tokensHoy: Long,
)

/** Un modo del asistente (CONSULTA o PASOS) con su ficha completa. */
data class AsistenteAgente(
    val id: String,
    val nombre: String,
    val modo: String,
    val maxPasos: Int,
    val herramientas: List<String>,
    val activo: Boolean,
    val proveedorPrincipalId: String?,
    val proveedorRespaldoId: String?,
)

/** Configuración completa del asistente para la pantalla de Agentes. */
data class AsistenteConfiguracion(
    val habilitado: Boolean,
    val chatLibre: Boolean,
    val proveedores: List<AsistenteProveedor>,
    val agentes: List<AsistenteAgente>,
    val herramientasDisponibles: List<String>,
    val catalogo: List<AsistenteCatalogo>,
)

/** Datos para crear o editar una cuenta. clave null o vacía = conservar la guardada. */
data class AsistenteDatosProveedor(
    val nombre: String,
    val tipo: String,
    val baseUrl: String?,
    val modelo: String,
    val activo: Boolean,
    val limiteMensualCents: Long,
    val limiteDiarioTokens: Long,
    val maxTokensSalida: Int,
    val precioEntradaPorMillon: Long,
    val precioSalidaPorMillon: Long,
    val clave: String?,
)

/** Datos para editar la ficha de un agente. */
data class AsistenteDatosAgente(
    val activo: Boolean,
    val maxPasos: Int,
    val herramientas: List<String>,
    val proveedorPrincipalId: String?,
    val proveedorRespaldoId: String?,
)
